<template>
    <div class="seller__office">
        <div class="seller__office-info">
            <span class="seller__office-name" v-if="office.branch_name">Филиал <span class="seller__office-number">{{ office.branch_name }}</span></span>
            <span class="seller__office-item" v-if="office.address">Адрес: <span class="seller__office-value">{{ office.city.title }}, {{ office.address }}</span></span>
            <span class="seller__office-item" v-if="office.working_hours">Время работы: <span class="seller__office-value">{{ office.working_hours }}</span></span>
            <span class="seller__office-item" v-if="office.contact_phones">Телефоны: <span class="seller__office-value">{{ office.contact_phones }}</span></span>
            <span class="seller__office-item" v-if="office.how_to_get">Как добраться: <span class="seller__office-value">{{ office.how_to_get }}</span></span>
        </div>
        <div class="seller__office-images">
            <div class="seller__office-img-box" v-for="photo in office.photos">
                <img :src="photo.url" alt="#" class="seller__office-img">
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import {store} from "../../../store/office";

    export default {
        name: "officeInfo",
        store,
        computed: {
            ...mapState([
                'office'
            ]),
        },
    }
</script>